<template>
  <TextField
    :id="id"
    v-model="content"
    :name="name"
    :labelName="labelName"
    type="email"
    autocomplete="email"
    :helperText="emailHelperText"
    :status="emailStatus"
    @blur="validateEmail"
  />
</template>

<script lang="ts">
import TextField from '../textfield/TextField.vue';
import helperStatus from '../../helpers/status';
import { emailCorrectionSuggestion, validateEmail } from '../../helpers/emailHelper';

export default {
  name: 'EmailTextField',
  components: { TextField },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: '',
      required: true,
    },
    helperText: {
      type: String,
      default: '',
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
  },
  data(): any {
    return {
      content: this.value,
      emailHelperText: this.helperText,
      emailStatus: this.status,
    };
  },
  computed: {
    emailIsValid(): boolean {
      return !!validateEmail(this.content);
    },
    emailCorrection(): string {
      return emailCorrectionSuggestion(this.content);
    },
  },
  watch: {
    content(value: string) {
      this.$emit('input', value);

      // When in non-neutral state, helper text & status should be reset on input
      if (this.emailStatus !== helperStatus.Neutral) {
        this.resetState();
      }
    },
    helperText(helperTextFromParent) {
      this.emailHelperText = helperTextFromParent;
    },
    status(statusFromParent) {
      this.emailStatus = statusFromParent;
    },
  },
  methods: {
    setValidationState(message: string, status: helperStatus) {
      this.emailHelperText = message;
      this.emailStatus = status;
      this.$emit('update:status', status);
    },
    resetState() {
      this.emailHelperText = this.helperText;
      this.emailStatus = helperStatus.Neutral;
      this.$emit('update:status', helperStatus.Neutral);
    },
    validateEmail() {
      if (!this.emailIsValid) {
        this.setValidationState('Enter an email address in the format name@example.com', helperStatus.Error);
      } else if (this.emailCorrection) {
        this.setValidationState(`Did you mean <b>${this.emailCorrection.toUpperCase()}</b>?`, helperStatus.Warn);
      } else {
        this.resetState();
      }
    },
  },
};
</script>
